module.exports = __webpack_public_path__ + "img/footer-bg.be0becef.png";